import { Box, FormControl, MenuItem, Select } from "@mui/material";
import { AllLanguagesCode } from "../utility";
import i18next, { t } from "i18next";

const LanguagesOptions = ({ handleLanguage, firstLaunchLang, login }) => {
  const detectLang = () => {
    const language = AllLanguagesCode.filter((lang) => {
      return navigator.language.includes(lang);
    });

    if (!localStorage.getItem("lang")) {
      const selectedLanguage = language[0];
      i18next.changeLanguage(selectedLanguage);
      document.querySelector("html").lang = selectedLanguage;
      localStorage.setItem("lang", selectedLanguage);
      return selectedLanguage;
    } else {
      return localStorage.getItem("lang");
    }
  };

  return (
    <Box
      variant="standard"
      sx={
        firstLaunchLang == 1
          ? localStorage.getItem("lang") === "ar" ||
            localStorage.getItem("lang") === "fa"
            ? {
                marginInline: "22px",
                marginBottom: "12px",
                marginTop: "0px",
                position: "absolute",
                top: 45,
                right: 0,
                border: "none",
              }
            : {
                marginInline: "22px",
                marginBottom: "12px",
                marginTop: "0px",
                position: "absolute",
                top: 45,
                right: 0,
                border: "none",
              }
          : login == 1
          ? localStorage.getItem("lang") === "ar" ||
            localStorage.getItem("lang") === "fa"
            ? {
                marginInline: "22px",
                marginBottom: "12px",
                marginTop: "0px",
                position: "absolute",
                top: 0,
                right: 12,
                border: "none",
              }
            : {
              marginInline: "22px",
              marginBottom: "12px",
              marginTop: "0px",
              position: "absolute",
              top: 0,
              left: 12,
              border: "none",
              }
          : {
              marginInline: "22px",
              marginBottom: "12px",
              marginTop: "0px",
              position: "absolute",
              top: 0,
              right: 12,
              border: "none",
            }
      }
    >
      <FormControl fullWidth sx={{ border: "none" }}>
        <Select
          labelId="demo-simple-select-autowidth-label"
          id="demo-simple-select-autowidth"
          disableUnderline={true}
          variant="standard"
          value={detectLang().toString()}
          onChange={handleLanguage}
        >
          <MenuItem className="p-2 sub-font" value="ar">
            {t("Arabic") + " ( العربية ) "}
          </MenuItem>
          <MenuItem className="p-2 sub-font" value="en">
            {t("English") + " ( English ) "}{" "}
          </MenuItem>
          <MenuItem className="p-2 sub-font" value="fr">
            {t("French") + " ( Français ) "}{" "}
          </MenuItem>
          <MenuItem className="p-2 sub-font" value="zh-Hans">
            {t("Chinese") + " ( 中国人 ) "}{" "}
          </MenuItem>
          <MenuItem className="p-2 sub-font" value="ca">
            {t("Catalan") + " ( català ) "}{" "}
          </MenuItem>
          <MenuItem className="p-2 sub-font" value="hr">
            {t("Croatian") + " ( Hrvatski ) "}{" "}
          </MenuItem>
          <MenuItem className="p-2 sub-font" value="cs">
            {t("Czech") + " ( čeština ) "}{" "}
          </MenuItem>
          <MenuItem className="p-2 sub-font" value="da">
            {t("Danish") + " ( dansk ) "}{" "}
          </MenuItem>
          <MenuItem className="p-2 sub-font" value="nl">
            {t("Dutch") + " ( Nederlands ) "}{" "}
          </MenuItem>
          <MenuItem className="p-2 sub-font" value="et">
            {t("Estonian") + " ( eesti keel ) "}{" "}
          </MenuItem>
          <MenuItem className="p-2 sub-font" value="de">
            {t("German") + " ( Deutsch ) "}{" "}
          </MenuItem>
          <MenuItem className="p-2 sub-font" value="hu">
            {t("Hungarian") + " ( Magyar ) "}{" "}
          </MenuItem>
          <MenuItem className="p-2 sub-font" value="it">
            {t("Italian") + " ( Italiano ) "}{" "}
          </MenuItem>
          <MenuItem className="p-2 sub-font" value="mk">
            {t("Macedonian") + " ( македонски ) "}{" "}
          </MenuItem>
          <MenuItem className="p-2 sub-font" value="nb">
            {t("Norwegian") + " ( norsk ) "}{" "}
          </MenuItem>
          <MenuItem className="p-2 sub-font" value="fa">
            {t("Persian") + " ( فارسی ) "}{" "}
          </MenuItem>
          <MenuItem className="p-2 sub-font" value="pt">
            {t("Portuguese-br") + " ( Brasil português ) "}{" "}
          </MenuItem>
          <MenuItem className="p-2 sub-font" value="pt-pt">
            {t("Portuguese-pt") + " ( Português ) "}{" "}
          </MenuItem>
          <MenuItem className="p-2 sub-font" value="ro">
            {t("Romanian") + " ( Română ) "}{" "}
          </MenuItem>
          <MenuItem className="p-2 sub-font" value="ru">
            {t("Russian") + " ( Русский ) "}{" "}
          </MenuItem>
          <MenuItem className="p-2 sub-font" value="ja">
            {t("Japanese") + " ( 日本語 ) "}{" "}
          </MenuItem>
          <MenuItem className="p-2 sub-font" value="ko">
            {t("Korean") + " ( 한국인 ) "}{" "}
          </MenuItem>
          <MenuItem className="p-2 sub-font" value="es">
            {t("Spanish") + " ( Español ) "}{" "}
          </MenuItem>
          <MenuItem className="p-2 sub-font" value="tr">
            {t("Turkish") + " ( Türkçe ) "}{" "}
          </MenuItem>
          <MenuItem className="p-2 sub-font" value="uk">
            {t("Ukranian") + " ( українська ) "}{" "}
          </MenuItem>
          <MenuItem className="p-2 sub-font" value="sv">
            {t("Swedish") + " ( svenska ) "}{" "}
          </MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

export default LanguagesOptions;
